import React from "react";
//#region types
import { DateInputProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { FormControl } from "@mui/material";
import SimpleDatePicker from "../../datePickers/simpleDatePicker";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const DateInput: React.FC<DateInputProps> = (props: DateInputProps) => {
  const isDateValid = (date: Date) => {
    if (!props.validDates || props.validDates.length === 0) return true;
    return props.validDates.some((d) => d.toDateString() === date.toDateString());
  };

  const shouldDisableDate =
    props.validDates && props.validDates.length > 0 ? (date: Date) => !isDateValid(date) : undefined;

  const onChange = (date?: Date) => {
    if (date && !isDateValid(date)) {
      props.setValue(undefined);
      return;
    }
    props.setValue(date);
  };

  return (
    <FormControl fullWidth className={cssExports.inputFormControl}>
      <SimpleDatePicker
        disabled={props.disabled}
        inputFormat="yyyy-MM-dd"
        label={props.label}
        overridePlaceholder={`${props.label}${
          props.optional
            ? `${props.label ? " " : ""}(${LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.Common.Optional
              )})`
            : ""
        }`}
        value={props.value}
        defaultCalendarMonth={props.initialFocusedDate}
        error={props.hasError}
        name={props.name}
        onChange={onChange}
        onBlur={props.onBlur}
        minDate={props.minDate}
        maxDate={props.maxDate}
        shouldDisableDate={shouldDisableDate}
        className={props.className}
        data-testid={`${props.name}DateInput`}
      />
    </FormControl>
  );
};

export default DateInput;
